var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logo" },
    [
      _vm._t("default", null, {
        updateLogoCalc: _vm.updateLogoCalc,
        imageContainerWidth: _vm.imageContainerWidth,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }